export const CROPPED_PICTURE = (croppedData) => ({
    type: 'CROPPED_PICTURE',
    payload: croppedData
})
